<template>
  <div id="app">
    <h1>Hello Vue on World!</h1>
    <p>This web is Under Construction.</p>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  text-align: center;
  margin-top: 50px;
}
</style>